import { Controller } from "@hotwired/stimulus"
import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk"

export default class extends Controller {
  connect () {
    // Eigene SDK-Instanz pro Widget-Mount (statt geteiltem Singleton): Turbo tauscht bei
    // Navigation/Validierungsfehlern den <body> aus, wodurch das alte Agent-Iframe aus dem
    // DOM verschwindet. Ein geteilter Singleton würde dessen (dann totes) Iframe weiter
    // cachen ("Waiting for connection to website..."). Mit einer eigenen Instanz räumt
    // disconnect() nur die eigenen Ressourcen auf, ohne parallel verbindende Geschwister-
    // Widgets zu stören.
    this.sdk = new FriendlyCaptchaSDK();
    this.widget = this.sdk.createWidget({
      element: this.element,
      sitekey: this.element.getAttribute("data-sitekey"),
      startMode: "auto"
    });
  }

  disconnect() {
    this.sdk.clear()
  }
}
